import { IconName, SizeProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import "./MultiSeletor.scss"

type Props = {
    onChange: (value: string) => void,
    value: string,
    options: MultiSeletorOption[],
    width: number | string,
    itemWidth: number | string,
    iconSize?: SizeProp,
    bgColor?: string
}

type MultiSeletorOption = {
    label: string,
    value: string,
    icon?: string,
    textIcon?: string,
    color: string,
}

export default function MultiSeletor(props: Props) {

    const getClassName = (index: number) => {
        let className = "opcao-container";
        if (index === props.options.length - 1) {
            className += " ultima-opcao";
        } else {
            className += " nao-ultima-opcao";
        }
        if (index === 0) {
            className += " primeira-opcao";
        }
        return className;
    }

    return (
        <div style={{ display: "flex", flex: 1, alignItems: "center", justifyContent: "center", marginTop: 2 }} >
            <div style={{ display: "flex", flexDirection: "row", width: props.width, borderRadius: 10, borderColor: "#AAAAAA", borderWidth: 1, backgroundColor: props.bgColor||"#eaeaea" }} >
                {props.options.map((opcao, index) => {
                    return <div
                        key={index}
                        className={getClassName(index)}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: props.itemWidth,
                            paddingTop: 3,
                            paddingBottom: 3,
                            ...props.value == opcao.value ? { backgroundColor: opcao.color } : {},
                        }}
                        onClick={() => opcao.value == props.value ? props.onChange("") : props.onChange(opcao.value)}
                    >
                        {opcao.icon ? <FontAwesomeIcon icon={opcao.icon as IconName} size={props.iconSize||"5x"} color={props.value == opcao.value ? "#FFF" : opcao.color} /> : null}
                        {opcao.textIcon && !opcao.icon ? <span style={{ fontSize: 47, color: props.value == opcao.value ? "#FFF" : opcao.color }} >{opcao.textIcon}</span> : null}
                        <label style={{ textAlign: "center", ...props.value == opcao.value ? { color: "#FFF", fontWeight: 700 } : { color: "#000" } }}>{opcao.label}</label>
                    </div>
                })}
            </div>
        </div>
    )
}